<template>
    <v-container fluid>
        <v-layout row wrap>
            <DocumentSearchForm/>

            <v-flex v-for="(directoryContainer, directorySlug) in mediasByDirectories" :key="directorySlug" xs12>
                <v-flex xs12 class="pa-2 headline">
                    {{ directoryContainer.directoryFullName}}

                    <router-link :to="{ name: 'directory-show', params: { slug: directorySlug }}" >
                        <v-icon class="blue--text" medium>link</v-icon>
                    </router-link>
                </v-flex>

                <v-layout row wrap>
                    <DocumentItem v-for="document in directoryContainer.documents" :key="document.slug" :document="document"/>
                </v-layout>
            </v-flex>

            <MediaFullScreen/>
        </v-layout>
    </v-container>
</template>

<script>
    import DocumentItem from "../../components/document/DocumentItem";
    import DocumentSearchForm from "../../components/form/DocumentSearchForm";
    import {mapGetters} from "vuex";
    import MediaFullScreen from "../../components/document/MediaFullScreen";
    import {DOCUMENTS_CLEAR} from "../../store/actions.type";

    export default {
        name: "DocumentSearch",
        components: {
            MediaFullScreen,
            DocumentItem,
            DocumentSearchForm
        },
        computed: {
            ...mapGetters(["mediasByDirectories"]),
        },
        mounted() {
            this.$store.dispatch(DOCUMENTS_CLEAR);
        }
    };
</script>

<style scoped lang="scss">
</style>
